export const PERMISSIONS = {
  READ_USERS : 'read-users',
  READ_STAFF: 'read-staff',
  WRITE_STAFF: 'write-staff',
  APPROVE_STAFF: 'approve-staff',
  READ_ROLES: 'read-role',
  WRITE_ROLES: 'write-role',
  APPROVE_ROLES: 'approve-role',
  READ_PERMISSIONS: 'read-permissions',
  READ_TRANSACTIONS: 'read-transactions',
  TRANSACTION_MAKER: 'transaction-maker',
  TRANSACTION_CHECKER: 'transaction-checker',
  WRITE_BANK_TRANSACTIONS: 'write-bank-transactions',
  READ_BANK_TRANSACTIONS: 'read-bank-transactions',
  READ_AUDIT_TRAIL: 'read-audit-trail',
  READ_CONFIGURATIONS: 'read-configurations',
  WRITE_CONFIGURATIONS: 'write-configurations',
  VIEW_LOANS: 'view-loan',
  BROADCAST_LOANS: 'broadcast-loan',
  REJECT_LOANS: 'reject-loan',
  DISBURSE_LOANS: 'disburse-loan',
  APPROVE_DISBURSEMENT: 'approve-disbursement',
  REJECT_DISBURSEMENT: 'reject-disbursement',
  REJECT_WITHDRAW: 'reject-withdraw',
  APPROVE_WITHDRAW: 'approve-withdraw'
}

export const PERMISSION_MESSAGE_MAP = {
  [PERMISSIONS.READ_USERS] : 'You don\'t have permission to view users.',
  [PERMISSIONS.READ_STAFF] : 'You don\'t have permission to view staff users.',
  [PERMISSIONS.WRITE_STAFF] : 'You don\'t have permission to manage staff users.',
  [PERMISSIONS.APPROVE_STAFF] : 'You don\'t have permission to approve staff users.',
  [PERMISSIONS.READ_ROLES] : 'You don\'t have permission to view roles.',
  [PERMISSIONS.WRITE_ROLES] : 'You don\'t have permission to manage roles.',
  [PERMISSIONS.APPROVE_ROLES] : 'You don\'t have permission to approve a role.',
  [PERMISSIONS.READ_PERMISSIONS] : 'You don\'t have permission to view permissions.',
  [PERMISSIONS.READ_TRANSACTIONS] : 'You don\'t have permission to view transactions.',
  [PERMISSIONS.TRANSACTION_MAKER] : 'You don\'t have permission to create transactions.',
  [PERMISSIONS.TRANSACTION_CHECKER] : 'You don\'t have permission to approve transactions.',
  [PERMISSIONS.WRITE_BANK_TRANSACTIONS] : 'You don\'t have permission to record bank transactions.',
  [PERMISSIONS.READ_BANK_TRANSACTIONS]: 'You don\'t have permission to view bank transactions.',
  [PERMISSIONS.READ_AUDIT_TRAIL] : 'You don\'t have permission to see audit trail.',
  [PERMISSIONS.READ_CONFIGURATIONS]: 'You don\'t have permission to view configurations.',
  [PERMISSIONS.WRITE_CONFIGURATIONS] : 'You don\'t have permission to change configurations.',
  [PERMISSIONS.WRITE_CONFIGURATIONS] : 'You don\'t have permission to change configurations.',
  [PERMISSIONS.VIEW_LOANS]: 'You don\'t have permission to view loans',
  [PERMISSIONS.BROADCAST_LOANS]: 'You don\'t have permission to broadcast loans',
  [PERMISSIONS.REJECT_LOANS]: 'You don\'t have permission to reject loans',
  [PERMISSIONS.DISBURSE_LOANS]: 'You don\'t have permission to disburse loans',
  [PERMISSIONS.APPROVE_DISBURSEMENT]: 'You don\'t have permission to approve loan disbursements',
  [PERMISSIONS.REJECT_DISBURSEMENT]: 'You don\'t have permission to reject loan disbursements',
  [PERMISSIONS.REJECT_WITHDRAW]: "You don't have permission to reject withdraw requests",
  [PERMISSIONS.APPROVE_WITHDRAW]: "You don't have permission to approve withdraw requests"
}
